module.exports = __webpack_public_path__ + "img/image (21).0d109996.webp";